module.exports = __webpack_public_path__ + "media/images/photo_preview-b18792e1ff404520045fb480bb92306a.svg";